<script>
    import {onMount} from 'svelte';
    import Recommendation from '../Models/recommendationModel';
    import RecommendationRow from './RecommendationRow.svelte';

    import SuggestedSectionMappings from './SuggestedSectionMappings.svelte';

    import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

    export let assessment_model;
    export let category;
    export let control;
    export let assessment;

    export let has_legacy_recommendations_section;

    let recommendations = [];

    let section_mappings = {};

    let added_recommendations = new Set();


    async function loadRecommendations(control) {
        let updated_recommendations = [];
        let updated_section_mappings = {};

        async function addMapping(mapping) {
            let mapping_type;

            if (typeof mapping == "string") {
                mapping_type = mapping.split(":")[0];
            } else {
                mapping_type = mapping.type;
            }

            if (mapping_type == "stockRecommendation") {
                try {
                    let rec = await Recommendation.getStockRecommendation(mapping)
                    updated_recommendations = [...updated_recommendations, rec];
                } catch (e) {
                    console.info(e);
                }
            } else if (mapping_type == "library_item") {
                if (!updated_section_mappings[mapping.section_id]) {
                    updated_section_mappings[mapping.section_id] = [mapping];
                } else {
                    updated_section_mappings[mapping.section_id] = [...updated_section_mappings[mapping.section_id], mapping];
                }
            }
        }

        // check for answer recommendations
        let answer = assessment_model.getResult(control.id, '', assessment).value;

        if (control.recommendation_map && control.recommendation_map[answer]) {
            if (typeof control.recommendation_map[answer] == "string") {
                updated_recommendations.push(await Recommendation.getStockRecommendation(control.recommendation_map[answer]))
            } else {
                for (let mapping of control.recommendation_map[answer]) {
                    await addMapping(mapping);
                }
            }
        }

        // check for tag recommendations
        for (let tag of assessment.assessment_type_data.question_tags) {
            if (assessment.model.getTag(control.id, tag.tag_id).value) {
                // check if tag is mapped
                if (control.tag_mapping[tag.tag_id]) {
                    for (let mapping of control.tag_mapping[tag.tag_id]) {
                        await addMapping(mapping);
                    }
                }
            }
        }

        recommendations = updated_recommendations;
        section_mappings = updated_section_mappings;
    }

    function handleAddFindingClick(recommendation) {
        dispatch("addFinding", {recommendation})
    }

    function populate_added_recommendations(recommendations) {
        if (!recommendations) return

        added_recommendations = new Set();
        for (let rec of recommendations) {
            added_recommendations.add(rec.template_id);
        }
    }

    $: loadRecommendations(control);
    $: populate_added_recommendations(assessment.recommendations[category?.id])
</script>

{#if has_legacy_recommendations_section && recommendations.length}
<div>
    <h3 class="title is-4">Suggested Findings</h3>
    <table class="table NISTTable">
        {#each recommendations as recommendation (recommendation.id) }
            <RecommendationRow {recommendation} {added_recommendations}>
                <span class="button" on:click={() => handleAddFindingClick(recommendation)}>Add Finding</span>
            </RecommendationRow>
        {/each}
    </table>
</div>
{/if}

{#each Object.entries(section_mappings) as [section_id, mapped_items] (section_id)}
<div>
    <SuggestedSectionMappings {assessment} {section_id} {mapped_items} {control} />
</div>
{/each}